export class LookupConstants {
    static TEMPLATE_TYPES = ["Email", "Letter", "SMS"];
    static YES_NO = ["Yes", "No"];
    static INVOICE_TYPES = ["Invoice", "Quote", "Deposit"];
    static RECIPIENT_GROUP_SETTING_TYPES = ["Internal", "External"];
    static STAMP_TYPES = ["Custom"];
    static STAMP_OPTIONS = ["Date", "My name", "Reference number"];
    static RESUBMISSION_PERIOD_UNITS = ["Day", "Month", "Year"];
    static PROVINCE = [
        "Eastern Cape",
        "Free State",
        "Gauteng",
        "KwaZulu-Natal",
        "Limpopo",
        "Mpumalanga",
        "North West",
        "Northern Cape",
        "Western Cape",
    ];
    static COUNTRIES = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia & Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Cote D Ivoire",
        "Croatia",
        "Cruise Ship",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Polynesia",
        "French West Indies",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kuwait",
        "Kyrgyz Republic",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Pakistan",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Pierre & Miquelon",
        "Samoa",
        "San Marino",
        "Satellite",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "St Kitts & Nevis",
        "St Lucia",
        "St Vincent",
        "St. Lucia",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor L\"Este",
        "Togo",
        "Tonga",
        "Trinidad & Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks & Caicos",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Virgin Islands (US)",
        "Yemen",
        "Zambia",
        "Zimbabwe",
    ];
    static COMMUNICATION_DIRECTION = [
        "Incoming",
        "Outgoing"
    ];
    static COMMUNICATION_MECHANISM = [
        "By hand",
        "Collected",
        "Email",
        "Fax",
        "In Person",
        "Letter",
        "Not Applicable",
        "Ordinary Mail",
        "Registered Mail",
        "Telephone",
        "WhatsApp",
    ];
    static REPORT_FREQUENCY = [
        "Monthly",
        "Once",
        "Quarterly",
        "Weekly",
        "Yearly"
    ];
    static MARITAL_STATUS_LOOKUPS_RECIPIENT_COMPONENTS = [
        "Divorced",
        "Married",
        "Never married",
        "Registered partnership",
        "Separated"
    ];
    static EMPLOYMENT_STATUS_LOOKUPS_RECIPIENT_COMPONENTS = [
        "Employed",
        "Retired",
        "Unemployed",
    ];
    // advertising module start
    static REMOVAL_PERIOD_LOOKUPS_A = [
        { code: "60 days", value: "60 days" },
        { code: "90 days", value: "90 days" }
    ];
    static NON_ILLUMINATED_BILLBOARD_A = [
        { code: "Not applicable", value: "Not applicable" },
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A = [
        { code: "Not applicable", value: "Not applicable" },
        { code: "Double Sided", value: "Double Sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static NON_ILLUMINATED_GANTRY_A = [
        { code: "Not applicable", value: "Not applicable" },
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static DIGITAL_GANTRY_A = [
        { code: "Not applicable", value: "Not applicable" },
        { code: "Double sided", value: "Double sided" },
        { code: "Single sided", value: "Single sided" }
    ];
    static PERMANENT_OR_TEMPORARY_LOOKUPS_A = [
        { code: "permanent", value: "permanent" },
        { code: "temporary", value: "temporary" }
    ];
    static AREA_OF_DISPLAY_LOOKUPS_A = [
        { code: "Ballito", value: "Ballito" },
        { code: "KwaDukuza", value: "KwaDukuza" },
        { code: "Salt rock /Umhlali", value: "Salt rock /Umhlali" },
        { code: "Shakaskraal", value: "Shakaskraal" },
    ];
}
